import * as o from "react";
export function composeRefs() {
  for (var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++) {
    o[_key] = arguments[_key];
  }
  return e => o.forEach(o => function (o, e) {
    "function" == typeof o ? o(e) : null != o && (o.current = e);
  }(o, e));
}
export function useComposedRefs() {
  for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    e[_key2] = arguments[_key2];
  }
  return o.useCallback(composeRefs(...e), e);
}